import { useEffect } from "react";

import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { useGetSessionMutation } from "@sso/apis/login";
import { LocalStorageKeys, PathKeys } from "@sso/constant";
import { logOutUser } from "@sso/store/slices/auth";
import { CircleLoading } from "@sso/ui/CircleLoading";
import { Flex } from "@sso/ui/FlexBox";
import { Typography } from "@sso/ui/Typography";
import { localStorageHelper } from "@sso/utils";

export const LoadingApp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [getSessionRequest] = useGetSessionMutation();

  useEffect(() => {
    if (location.pathname === PathKeys.PAYMENT) {
      return navigate(PathKeys.PAYMENT);
    } else if (location.pathname === PathKeys.PURCHASE_LICENCE) {
      return navigate(PathKeys.PURCHASE_LICENCE);
    }

    const token = localStorageHelper.getItem(LocalStorageKeys.TOKEN);

    if (!token && location.pathname !== PathKeys.PAYMENT && location.pathname !== PathKeys.PURCHASE_LICENCE) {
      return navigate(PathKeys.SIGN_IN);
    }
    const getSession = async () => {
      await getSessionRequest()
        .unwrap()
        .catch(error => {
          if (error.status === 401) {
            dispatch(logOutUser());
            return navigate(PathKeys.SIGN_IN);
          }
        });
    };

    getSession();
  }, [getSessionRequest, navigate]);

  return (
    <>
      <CircleLoading size={10} />
      <Flex position="absolute" width="100%" top="60%">
        <Typography fontWeight="bold">Loading Data ...</Typography>
      </Flex>
    </>
  );
};
